import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiBOTypesData } from "./types";

interface BoTypesResponse {
    botypes: ApiBOTypesData[];
}

/**
 * Транспортный слой OMP — типы БО.
 */
export const boTypesApi = {
    /**
     * Возвращает информацию о типах БО.
     * Запрос уходит в endpoint `bo.loadBOTypes`.
     */
    loadBOTypes: async (config?: RequestConfig): Promise<ApiBOTypesData[]> => {
        const data = await ompApiClient.postOmega<BoTypesResponse>("bo.loadBOTypes", {}, config);
        return data.botypes ?? [];
    },
} as const;
